import { render } from "./TabSamTermsList.vue?vue&type=template&id=ccf70140"
import script from "./TabSamTermsList.vue?vue&type=script&lang=js"
export * from "./TabSamTermsList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__